"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntervalTexts = exports.ForecastInterval = exports.ForecastGroupByFormat = exports.ForecastGroupByTexts = exports.ForecastGroupBy = void 0;
var ForecastGroupBy;
(function (ForecastGroupBy) {
    ForecastGroupBy["MONTH"] = "month";
    ForecastGroupBy["WEEK"] = "week";
    ForecastGroupBy["DAY"] = "day";
    ForecastGroupBy["HOUR"] = "hour";
    ForecastGroupBy["MINUTE"] = "minute";
})(ForecastGroupBy || (exports.ForecastGroupBy = ForecastGroupBy = {}));
exports.ForecastGroupByTexts = {
    [ForecastGroupBy.MONTH]: 'Month',
    [ForecastGroupBy.WEEK]: 'Week',
    [ForecastGroupBy.DAY]: 'Day',
    [ForecastGroupBy.HOUR]: 'Hour',
    [ForecastGroupBy.MINUTE]: '30 minutes',
};
exports.ForecastGroupByFormat = {
    [ForecastGroupBy.MONTH]: 'MMM YYYY',
    [ForecastGroupBy.WEEK]: 'YYYY-MM-DD',
    [ForecastGroupBy.DAY]: 'YYYY-MM-DD',
    [ForecastGroupBy.HOUR]: 'YYYY-MM-DD HH:mm',
    [ForecastGroupBy.MINUTE]: 'YYYY-MM-DD HH:mm',
};
var ForecastInterval;
(function (ForecastInterval) {
    ForecastInterval[ForecastInterval["NONE"] = 0] = "NONE";
    ForecastInterval[ForecastInterval["MIN_30"] = 30] = "MIN_30";
    ForecastInterval[ForecastInterval["HOURLY"] = 60] = "HOURLY";
    ForecastInterval[ForecastInterval["DAILY"] = 1440] = "DAILY";
    ForecastInterval[ForecastInterval["WEEKLY"] = 10080] = "WEEKLY";
    ForecastInterval[ForecastInterval["MONTHLY"] = 43200] = "MONTHLY";
})(ForecastInterval || (exports.ForecastInterval = ForecastInterval = {}));
exports.IntervalTexts = {
    [ForecastInterval.NONE]: 'none',
    [ForecastInterval.MIN_30]: '30-min',
    [ForecastInterval.HOURLY]: 'Hourly',
    [ForecastInterval.DAILY]: 'Daily',
    [ForecastInterval.WEEKLY]: 'Weekly',
    [ForecastInterval.MONTHLY]: 'Monthly',
};
